module.exports = __webpack_public_path__ + "img/pdf_logo.1d3124ee.png";